document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#productGridContainer .product-grid');
  const button = document.querySelector('#loadMore');
  const productCount = document.querySelector('#productCount');

  if (!grid || !button) return;

  // Derive section id from the nearest Shopify section wrapper
  // Looks like: <section id="shopify-section-template--xxx__main" ...>
  const sectionWrapper =
    grid.closest('[id^="shopify-section-"]') ||
    document.querySelector('[id^="shopify-section-"][data-section-type*="collection"]');
  const sectionId = sectionWrapper
    ? sectionWrapper.id.replace('shopify-section-', '')
    : null;

  const pageSize = parseInt(button.dataset.pageSize, 10);
  const totalItems = parseInt(button.dataset.totalItems, 10);

  let loadedCount = grid.querySelectorAll('.product-grid > *').length;
  let currentPage = 1;

  function buildNextUrl(page) {
    // Base path for the current collection
    const base = new URL(window.location.pathname, window.location.origin);

    // Start with current query params (preserve preview_theme_id, filters, sort, etc.)
    const params = new URLSearchParams(window.location.search);

    // Set/override the page param
    params.set('page', String(page));

    // Ensure we include the section id so Shopify returns only the section HTML
    if (sectionId) params.set('section_id', sectionId);

    base.search = params.toString();
    return base.toString();
  }

  async function fetchNextPage(page) {
    const url = buildNextUrl(page);
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  button.addEventListener('click', async () => {
    const nextPage = currentPage + 1;
    button.disabled = true;
    const prevText = button.textContent;
    button.textContent = 'LOADING';

    try {
      const doc = await fetchNextPage(nextPage);
      const newItems = doc.querySelectorAll('.product-grid > *');

      newItems.forEach((item) => {
        item.classList.add('fade-in-product');
        grid.appendChild(item);
      });

      loadedCount += newItems.length;
      const remaining = Math.max(totalItems - loadedCount, 0);
      const showing = Math.min(loadedCount, totalItems);

      if (productCount) {
        productCount.textContent = `Showing ${showing} of ${totalItems} products`;
      }

      if (remaining > 0 && newItems.length > 0) {
        button.textContent = 'LOAD MORE';
        button.disabled = false;
        currentPage = nextPage;
      } else {
        button.remove();
      }
    } catch (err) {
      console.error('Load More error:', err);
      button.textContent = prevText;
      button.disabled = false;
    }
  });
});